import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-3">
              / Témoignages /
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-900">
              Ce que disent nos utilisateurs
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              Découvrez les retours d&apos;expérience sur Hipobuy Spreadsheet
            </p>
          </div>

          <div className="columns-1 md:columns-2 lg:columns-3 gap-5">
            {testimonials.map((t, idx) => (
              <div
                key={t.handle}
                className="break-inside-avoid mb-5 bg-background-50 rounded-xl border border-background-200/60 p-5 hover:border-accent-200 transition-all duration-300"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div
                    className="w-10 h-10 rounded-full flex items-center justify-center font-heading font-bold text-sm"
                    style={{
                      backgroundColor: idx % 3 === 0 ? 'oklch(var(--accent-100))' : idx % 3 === 1 ? 'oklch(var(--primary-100))' : 'oklch(var(--secondary-100))',
                      color: idx % 3 === 0 ? 'oklch(var(--accent-700))' : idx % 3 === 1 ? 'oklch(var(--primary-700))' : 'oklch(var(--secondary-700))',
                    }}
                  >
                    {t.name.charAt(0)}
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-400">@{t.handle}</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  &ldquo;{t.content}&rdquo;
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}